export const uiSchema = (t, data) => {
  const fromTime = data.activeFrom && new Date(data.activeFrom).getTime();
  return {
    "ui:order": ["id", "name", "type", "active_from", "active_to", "*"],
    id: {
      "ui:widget": "hidden",
    },
    activeFrom: {
      "ui:widget": "date-picker",
    },
    activeTo: {
      "ui:widget": "date-picker",
      "ui:options": {
        minDate: new Date(fromTime - (fromTime % 86400000)).toISOString(),
      },
    },
    type: {
      "ui:widget": "hidden",
    },
  };
};
